import React from "react";
import ProjectTicketsPage from "./pages/ProjectTicketsPage";
import Layout from "./components/layout/Layout";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";


function App() {
      return (
        <Layout>
            
            <AuthenticatedTemplate>
                <ProjectTicketsPage />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>Please login...</p>
            </UnauthenticatedTemplate>
            
        </Layout>
    );
}

export default App;
